module.exports = __webpack_public_path__ + "img/edit_form.9447c082.svg";